import { isRgbPaintType } from '~/shared';
import { useLayoutSelector } from '../../redux';
import { CategoryTypes } from '../CategoryTab';
import { ColorPicker } from '../ColorPicker';

const RGBPalette = () => {
	const shouldShow = useLayoutSelector((state) => {
		const activePaintGroup = state.colorPicker.paintGroup;
		const activeCategory = state.carPaint.activeCategory;
		const sectionIndex = state.colorPicker.sectionIndex;

		if (!activePaintGroup || !activePaintGroup?.type) {
			return null;
		}

		if (sectionIndex === 1 && activeCategory === CategoryTypes.PaintingWorks) {
			return true;
		}

		return (
			isRgbPaintType(activePaintGroup!.type) &&
			activeCategory !== CategoryTypes.PaintingWheels
		);
	});

	if (!shouldShow) return null;

	return <ColorPicker />;
};

export { RGBPalette };
